<template>
  <div style="height: 100%">
    <list-form
      ref="list-form"
      :config="config"
      :formModel="formModel"
    >
      <template v-slot="{ data, item, autoSave }">
        <activity-item
          :displayActivityLog="displayActivityLog"
          :data="data"
          :item="item"
          :formModel="formModel"
          :autoSave="autoSave"
        >
          <template v-slot:user-actions>
            <button type="button" class="btn btn-size-s" @click="handlerConnect(data)">
              {{L10n('display-customer-po-followup')}}
            </button>
          </template>
        </activity-item>
      </template>
    </list-form>
    <dialog-status-repair-order />
    <dialog-new-instruction-repair-order />
    <dialog-status-customer />
    <dialog-new-instruction-customer />
    <dialog-connect
      ref="dialog-connect"
    ></dialog-connect>
  </div>
</template>

<script>
import { ListConfig } from './ListFormConfig.js'
import { waitValue } from '@/utils/promises.js'
import { ModelOpenPO } from '@/models/RepairExchangeOrder'
export default {
  name: 'ListFormOpenPO',
  components: {
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'dialog-status-repair-order': () => import(/* webpackChunkName: 'DialogStatusRepairOrder' */ '@/components/Shared/ActivityDialogStatusEmailRepairOrder'),
    'dialog-new-instruction-repair-order': () => import(/* webpackChunkName: 'DialogNewInstructionRepairOrder' */ '@/components/Shared/ActivityDialogNewInstructionRepairOrder'),
    'dialog-new-instruction-customer': () => import(/* webpackChunkName: 'DialogNewInstructionCustomer' */ '@/components/Shared/ActivityDialogNewInstructionCustomer'),
    'dialog-status-customer': () => import(/* webpackChunkName: 'ActivityDialogStatusEmailCustomer' */ '@/components/Shared/ActivityDialogStatusEmailCustomer'),
    'activity-item': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityItemOpenPO/Index'),
    'dialog-connect': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityConnectToCustomerPoFollowUp/Index')
  },
  created () {
    this.$bus.$on('open-wo-on-filter', this.handlerFilter)
    this.$bus.$on('export-supplier', this.handlerExportSupplier)
  },
  beforeDestroy () {
    this.$bus.$off('open-wo-on-filter', this.handlerFilter)
    this.$bus.$off('export-supplier', this.handlerExportSupplier)
  },
  props: {
    displayActivityLog: { type: Boolean, required: true },
    orderBy: { type: Number, required: true }
  },
  watch: {
    orderBy () {
      this.getListForm()
        .then(list => list.loadData())
    }
  },
  computed: {
    config () {
      return ListConfig(this.orderBy)
    }
  },
  methods: {
    formModel () {
      return new ModelOpenPO()
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    handlerFilter (filterValue) {
      this.getListForm()
        .then((list) => {
          list.setFilters(filterValue)
          list.loadData()
        })
    },
    handlerExportSupplier ({ isAll }) {
      this.getListForm()
        .then((listForm) => {
          listForm.exportToExcel({ isAll })
        })
    },
    handlerConnect ({ rfqid }) {
      this.$refs['dialog-connect'].show({ rfqid })
    }
  }
}
</script>
